import { render, staticRenderFns } from "./companyEvaluate.vue?vue&type=template&id=55000c4a&scoped=true"
import script from "./companyEvaluate.vue?vue&type=script&lang=js"
export * from "./companyEvaluate.vue?vue&type=script&lang=js"
import style0 from "./companyEvaluate.vue?vue&type=style&index=0&id=55000c4a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55000c4a",
  null
  
)

export default component.exports